(function () {
  'use strict';
  class Controller {}
  angular
    .module('actions')
    .component('userUpdateAction', {
      controller: Controller,
      templateUrl: 'actions/user/update/update-user.action.html',
      bindings: {
        userId: '<',
        user: '<',
        then: '&',
        catch: '&'
      }
    });
}());
